import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export function SheetBody({ className, children }: ComponentProps<'div'>) {
  return <div className={twMerge('flex-1 overflow-y-auto p-6', className)}>{children}</div>
}
